/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * scrollTrigger-trigger.js
 *
 * 指定クラスの位置までスクロールして,実行するアニメーション用
 *
 */

/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * 初期設定
 */
/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/
import gsap from "gsap";
import scrollTrigger from "gsap/ScrollTrigger";
gsap.registerPlugin(scrollTrigger);
import { setCreateSpan } from "../setCreateSpan";

setCreateSpan();

//定義
let speed = 0.7;
const Trigger = document.querySelectorAll(".trigger");
const scrubTrigger = document.querySelectorAll(".scrubTrigger");
const Fadein = document.querySelectorAll(".fadein");
const FadeinTrain = document.querySelectorAll(".fadein__train");
const SlideLeft = document.querySelectorAll(".slide__left");
const SlideUpTrain = document.querySelectorAll(".slide__up__train");
const Cover = document.querySelectorAll(".cover__create");

//シャッター要素生成
for (let i = 0; i < Cover.length; i++) {
	let createCover = document.createElement("span");
	createCover.className = "cover";
	Cover[i].appendChild(createCover);
}

/**
 * set
 */
/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/
gsap.set([Fadein], {
	opacity: 0,
});
gsap.set([FadeinTrain], {
	opacity: 0,
});
gsap.set([SlideUpTrain], {
	yPercent: 30,
	opacity: 0,
});
gsap.set([SlideLeft], {
	xPercent: 30,
	opacity: 0,
});

/**
 * Trigger
 * 指定クラスの位置までスクロールして,実行する
 */
/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/
const setTrigger = () => {
	for (let i = 0; i < Trigger.length; i++) {
		gsap.to(Trigger[i].querySelectorAll(".fadein"), {
			opacity: 1,
			duration: speed,
			scrollTrigger: {
				trigger: Trigger[i],
				start: "top 75%",
				//   markers: true,
			},
		});
		gsap.to(Trigger[i].querySelectorAll(".fadein__train"), {
			opacity: 1,
			duration: speed,
			scrollTrigger: {
				trigger: Trigger[i],
				start: "top 75%",
				toggleActions: "play none none reset", // 一度実行したら
				//   markers: true,
			},
			stagger: {
				from: "start",
				amount: 0.7,
			},
		});
		gsap.to(Trigger[i].querySelectorAll(".slide__up__train"), {
			opacity: 1,
			yPercent: 0,
			duration: speed,
			scrollTrigger: {
				trigger: Trigger[i],
				start: "top 75%",
				toggleActions: "play none none reset", // 一度実行したら
				//   markers: true,
			},
			stagger: {
				from: "start",
				amount: 0.7,
			},
		});
		gsap.to(Trigger[i].querySelectorAll(".slide__left"), {
			opacity: 1,
			xPercent: 0,
			duration: speed,
			scrollTrigger: {
				trigger: Trigger[i],
				start: "top 75%",
				//   markers: true,
			},
		});
	}
};

/**
 * scrubTrigger
 * 指定クラスの位置からスクロール量で実行する
 */
/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/
const setScrubTrigger = () => {
	for (let i = 0; i < scrubTrigger.length; i++) {
		gsap.to(scrubTrigger[i].querySelectorAll(".img .cover"), {
			scaleY: 0,
			duration: speed,
			scrollTrigger: {
				trigger: scrubTrigger[i],
				start: "top 75%",
				end: "40% 75%",
				scrub: 1,
				// markers: true,
			},
			stagger: {
				from: "start",
				amount: 0.2,
			},
		});
		gsap.to(scrubTrigger[i].querySelectorAll(".movie .cover"), {
			scale: 1,
			duration: speed,
			scrollTrigger: {
				trigger: scrubTrigger[i],
				start: "top 75%",
				end: "40% 75%",
				scrub: 1,
				// markers: true,
			},
			stagger: {
				from: "start",
				amount: 0.2,
			},
		});
		gsap.to(scrubTrigger[i].querySelectorAll(".block__schedule .cover"), {
			opacity: 0.8,
			duration: speed,
			scrollTrigger: {
				trigger: scrubTrigger[i],
				start: "top 75%",
				end: "bottom 75%",
				scrub: 1,
				// markers: true,
			},
			stagger: {
				from: "start",
				amount: 0.2,
			},
		});
		if (window.matchMedia("(min-width: 600px)").matches) {
			var startPotision = "40% 75%";
		} else {
			var startPotision = "top 75%";
		}
		gsap.to(scrubTrigger[i].querySelectorAll(".headline .span__create > span"), {
			translateY: 0,
			opacity: 1,
			duration: speed,
			scrollTrigger: {
				trigger: scrubTrigger[i],
				start: startPotision,
				end: "80% 75%",
				scrub: 1,
				// markers: true,
			},
			stagger: {
				from: "start",
				amount: 0.5,
			},
		});
		gsap.to(scrubTrigger[i].querySelectorAll(".scaleDown"), {
			scale: 1,
			opacity: 1,
			duration: speed,
			scrollTrigger: {
				trigger: scrubTrigger[i],
				start: "30% 75%",
				end: "80% 75%",
				scrub: 1,
				// markers: true,
			},
			stagger: {
				from: "start",
				amount: 0.2,
			},
		});
	}
};

/**
 * Export.
 */
/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/
export { setTrigger, setScrubTrigger };
